const initAccordion = () => {
    const accordionLink = document.querySelector(".accordion-link");
    const accordionTextGallery = document.querySelector(".accordion-text-gallery");
    if (accordionLink || accordionTextGallery) {
        const arrayContainerItem = document.querySelectorAll(".container-item");
        if (arrayContainerItem && arrayContainerItem.length > 0) {
            arrayContainerItem.forEach(containerItem => {
                containerItem.addEventListener("click", () => {
                    const fatherContainerItem = containerItem.parentElement;
                    if (fatherContainerItem.classList.contains("active")) {
                        fatherContainerItem.classList.toggle("active");
                    }
                    else {
                        for (let i = 0; i < arrayContainerItem.length; i++) {
                            arrayContainerItem[i].parentElement.classList.remove("active");
                        }
                        fatherContainerItem.classList.toggle("active");
                    }
                });
            });
        }
    }
};
